import { PathConfig} from '@/types';
import { autoAppendSlash,  autoSliceSlash } from './index';
import { parseUrl, stringify as stringifyQuery } from 'query-string';
/**
 * _ariver_path=pages/stall-menu/index 时, 需要映射到 menu 页面
 */
const miniPath2WebPath = (ariverPath: string, pathConfig: PathConfig) => {
  const path = autoAppendSlash(ariverPath);
  const matchItem = pathConfig.routes.find(route => autoAppendSlash(route.miniPath) === path);

  return (pathConfig.prefix || '') + (matchItem?.webPath || '');
}

/**
 * 如果 query 参数带 schema 参数且没有 hash 时，需要进行自动跳转逻辑
 * @param originUrl 
 * @param ariverPath 
 * @param pathConfig 
 * @returns 
 */
const autoSchema = (originUrl: URL, ariverPath: string, pathConfig?: PathConfig) => {
  if (originUrl.hash || !ariverPath) return;

  if (pathConfig) {  
    originUrl.pathname = miniPath2WebPath(ariverPath, pathConfig);
    originUrl.hash = 'null'; // 防止无限循环
  } else {
    originUrl.hash = autoSliceSlash(ariverPath);
  }

  window.location.replace(originUrl.toString());
}

/**
 * 兼容老的 hash 模式
 * https://order.coolblog.com.my/page/coolblog/index.html#pages/stall-menu/index?storeId=xxx
 * 跳转到
 * https://order.coolblog.com.my/page/coolblog/menu?storeId=xxx#null

 * @param originUrl 
 * @param pathConfig 
 */
const compatibleHashUrl = (originUrl: URL, pathConfig?: PathConfig) => {
  if (!pathConfig || !originUrl.hash || originUrl.hash === '#null') return;
  const hashUrl = parseUrl(originUrl.hash.slice(1));

  const path = autoAppendSlash(hashUrl.url);
  const matchItem = pathConfig.routes.find(route => autoAppendSlash(route.miniPath) === path);
  if (!matchItem) return;

  originUrl.pathname = miniPath2WebPath(hashUrl.url, pathConfig);

  const resultQuery: Record<string, any> = {
    ...hashUrl.query
  };
  originUrl.searchParams.forEach((v, key) => {
    if (v) {
      resultQuery[key] = v;
    }
  });
  originUrl.search = stringifyQuery(resultQuery);
  originUrl.hash = 'null'; // 防止无限循环

  window.location.replace(originUrl.toString());
}

export function autoRedirect(pathConfig?: PathConfig) {
  try {
    const originUrl = new URL(window.location.href);
    if (originUrl.hash) {
      compatibleHashUrl(originUrl, pathConfig);
      return;
    }
    const schemaStr = originUrl.searchParams.get('schema') || '';
    if (!schemaStr) {
      return;
    }

    const schemaUrl = new URL(schemaStr);
    const ariverPath = schemaUrl.searchParams.get('_ariver_path') || '';
    if (!ariverPath){
      return;
    }

    autoSchema(originUrl, ariverPath, pathConfig);
    
  } catch (e) {
    console.log(e);
  }
}

